const ACCEPT_INVITATION_WITH_LOGIN_FORM_CSS_IDENTIFIERS = Object.freeze({
  block: 'c-login-form',
});

export { ACCEPT_INVITATION_WITH_LOGIN_FORM_CSS_IDENTIFIERS };
